import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "../i18n/i18n";
import { UserPreferencesContext } from "../contexts/UserPreferencesContext";

export function usePageTitle() {
	const location = useLocation();
	const { translate } = useTranslation();
	const { locale } = useContext(UserPreferencesContext);

	useEffect(() => {
		// Wait until translate is ready
		if (!translate || typeof translate !== "function") return;

		const pathname = location.pathname;

		// Mapping des chemins vers des titres
		const titles = {
			"/": translate("nav.home"),
			"/home": translate("home.title"),
			"/transactions-history": translate("history.title"),
			"/add-transaction": translate("add.title"),
			"/recurring-transactions": translate("recurring.title"),
			"/analysis": translate("analysis.title"),
			"/settings": translate("settings.title"),
			"/admin": translate("admin.title"),
			"/login": translate("nav.login"),
			"/register": translate("nav.register"),
			"/auth": translate("nav.login"),
			"/terms": translate("terms.title"),
			"/privacy-policy": translate("privacy.title"),
			"/404": translate("404.title"),
		};

		const appName = translate("app.title");

		const pageTitle =
			titles[pathname] ||
			(window.location.pathname !== "/" && translate("404.title")) ||
			appName;

		document.title = `${pageTitle} - ${appName}`;
	}, [location, translate, locale]);
}
